// extracted by mini-css-extract-plugin
export default {"tickGreen":"tickSquare_tickGreen__LsYTs","tickGrey":"tickSquare_tickGrey__zjy5p","tickRed":"tickSquare_tickRed__O7ZhW"};